import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class StorageListenerService {
  constructor() { }

  private storageSub= new Subject<string>();

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  async set(key: string, value: any, listenTo:string): Promise<any> {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      this.storageSub.next(listenTo);
      return true;
    } catch (reason) {
      console.log(reason)
      return false;
    }
  }
}
